import { Card, Empty } from "antd";
import { useNavigate } from "react-router-dom";
import {
  ExclamationCircleOutlined,
  ClockCircleOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { STATUS, CATEGORICAL } from "../crmDashboardUtils";

const titleCase = (s) => String(s || "").charAt(0).toUpperCase() + String(s || "").slice(1);

const TasksSnapshot = ({ kpis = {}, types = [] }) => {
  const navigate = useNavigate();

  const buckets = [
    { key: "overdue", label: "Overdue", count: Number(kpis.overdue_tasks || 0), color: STATUS.critical, icon: <ExclamationCircleOutlined /> },
    { key: "today", label: "Due today", count: Number(kpis.tasks_today || 0), color: STATUS.warning, icon: <ClockCircleOutlined /> },
    { key: "upcoming", label: "Upcoming", count: Number(kpis.upcoming_tasks || 0), color: CATEGORICAL[0], icon: <CalendarOutlined /> },
  ];
  const total = buckets.reduce((s, b) => s + b.count, 0);

  return (
    <Card className="crm-card" variant="borderless">
      <div className="crm-card-head">
        <div>
          <div className="crm-card-title">Open tasks</div>
          <div className="crm-card-sub">
            <b className="crm-card-figure">{total.toLocaleString()}</b> waiting on a follow-up
          </div>
        </div>
        <button type="button" className="crm-link" onClick={() => navigate("/crm/tasks")}>
          View all
        </button>
      </div>

      {total === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Nothing pending — you're all caught up" style={{ padding: "32px 0" }} />
      ) : (
        <>
          <div className="crm-stackbar" role="img" aria-label={buckets.map((b) => `${b.count} ${b.label.toLowerCase()}`).join(", ")}>
            {buckets
              .filter((b) => b.count > 0)
              .map((b) => (
                <div
                  key={b.key}
                  className="crm-stackbar-seg"
                  style={{ flexGrow: b.count, background: b.color }}
                  title={`${b.label}: ${b.count}`}
                />
              ))}
          </div>

          <div className="crm-task-buckets">
            {buckets.map((b) => (
              <button
                type="button"
                key={b.key}
                className="crm-task-bucket"
                onClick={() => navigate("/crm/tasks")}
              >
                <span className="crm-task-bucket-label">
                  <span className="crm-task-bucket-icon" style={{ color: b.color }}>{b.icon}</span>
                  {b.label}
                </span>
                <b className={b.key === "overdue" && b.count > 0 ? "danger" : ""}>{b.count.toLocaleString()}</b>
              </button>
            ))}
          </div>

          {types.length > 0 && (
            <div className="crm-task-types">
              <span className="crm-task-types-title">By type</span>
              {types.map((t) => (
                <span key={t.type} className="crm-chip">
                  {titleCase(t.type)} <b>{t.count}</b>
                </span>
              ))}
            </div>
          )}
        </>
      )}
    </Card>
  );
};

export default TasksSnapshot;
